function setupProductCalculator(container) {
  const buttons = container.querySelectorAll('[data-action]')

  if (buttons.length === 0) {
    return
  }

  let formFieldValues = new URLSearchParams();

  for(const key of Object.keys(container.dataset)) {
    if (key.indexOf('form') !== 0) continue;
    let field = key.replace(/^(form\.?)/, '')
    field = field[0].toLowerCase() + field.slice(1)

    formFieldValues.append('form.' + field, container.dataset[key]);
  }

  buttons.forEach((element) => {
    element.addEventListener('click', (event) => {
      const action = element.getAttribute("data-action");

      switch (action) {
        case 'submit-form':
          const fieldKey = element.getAttribute("data-key");
          const fieldValue = element.getAttribute("data-value");

          formFieldValues.append('form.' + fieldKey, fieldValue);

          window.location.href = buildProcessUrl(container.dataset.url, formFieldValues)
          break;
        default:
          console.log(`${action} not supported`);
      }
    });
  });
}

function buildProcessUrl(baseUrl, params) {
  const url = new URL(baseUrl)
  const searchParams = new URLSearchParams(window.location.search)
  const urlParams = new URLSearchParams({
    ...Object.fromEntries(url.searchParams),
    ...Object.fromEntries(searchParams),
    ...Object.fromEntries(params)
  });
  return `${url.origin}${url.pathname}?${urlParams}`
}

document.addEventListener('DOMContentLoaded', () => {
  const calculators = document.getElementsByClassName('calculator-container-form')

  if (calculators.length === 0) {
    return
  }

  for (let e of calculators) {
    setupProductCalculator(e)
  }
})
